module.exports = __webpack_public_path__ + "img/page-ico.f3986862.png";